'use strict';

var _require = require('../helpers/is'),
    isFunction = _require.isFunction;

module.exports = function get(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (this.items[key] !== undefined) {
    return this.items[key];
  }

  if (isFunction(defaultValue)) {
    return defaultValue();
  }

  if (defaultValue !== null) {
    return defaultValue;
  }

  return null;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/get.js
// module id = 1664
// module chunks = 2